import * as z from "zod";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

// User-acting OAuth grants are owned and revoked by the consenting user.
export const revokeOAuthGrant = mutator({
  schema: z.object({ id: z.string() }),
  resolve: {
    grant: { kind: "oauthGrant", from: "id" },
  },
  permissions: {
    none: "ownership-based: only the consenting user may revoke their grant",
  },
  fn: async ({ tx, ctx, args: { grant } }) => {
    if (grant.serviceAccountId || grant.userId !== ctx.userId) {
      throw userFacingError("OAuth grant not found");
    }
    await tx.mutate.oauthGrant.update({
      id: grant.id,
      revokedAt: Date.now(),
    });
  },
});
